export const WEEKDAY = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
export const SECONDS_PER_HOUR = 3600;
export const HOURS_PER_DAY  = 24;
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * HOURS_PER_DAY;
export const SECONDS_IN_TWO_DAYS = SECONDS_PER_DAY * 2;